import {
  Button,
  Container,
  Image,
  Loader,
  PasswordInput,
  Stack,
  Title,
} from '@mantine/core'
import useResetNewPasswordForm from '@v2/domains/auth/hooks/useResetPasswordForm.hook'

import logoImg from 'src/assets/WBF_Logo_Color.png'
import { appLocalLogo } from 'src/common/libs'

const ResetPasswordForm = () => {
  const { getFormProps, onSubmit, isLoading, isSuccess } =
    useResetNewPasswordForm()
  const logo = appLocalLogo.getData('logo') ?? logoImg

  return (
    <>
      {isSuccess ? (
        <Loader size="lg" />
      ) : (
        <Container>
          <Stack align="center" mb={34}>
            <Image src={logo} alt="Logo" w={120} mb={14} />
            <Title order={1}>Create New Password</Title>
          </Stack>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              onSubmit()
            }}
          >
            <Stack gap={35}>
              <PasswordInput
                id="password"
                label="NEW PASSWORD"
                placeholder="Enter Password"
                size="lg"
                {...getFormProps('password')}
              />
              <PasswordInput
                id="password-repeat"
                label="CONFIRM NEW PASSWORD"
                placeholder="Confirm new password"
                size="lg"
                mb={32}
                {...getFormProps('confirmPassword')}
              />
              <Button type="submit" size="lg" loading={isLoading} fullWidth>
                Change
              </Button>
            </Stack>
          </form>
        </Container>
      )}
    </>
  )
}

export default ResetPasswordForm
